import { styled } from '@mui/material';
import { palette } from 'assets/styles/colors';

export const StyledDiv = styled('div')`
  ul {
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: ${palette.blue[500]};
  }
`;
